import { formatPhoneNumber } from 'utils';
import template from './sms_delivery_log.html';

angular.module('bb.appointments').component('smsDeliveryLog', {
  transclude: true,
  bindings: { deliveryLog: '<', timezone: '<' },
  controller: LoadingController,
  controllerAs: 'vm',
  template,
});

function LoadingController() {
  const vm = this;
  vm.formatPhoneNumber = formatPhoneNumber;
}
